import task from "./task"
import scheduler from "./scheduler"
import position from "./position"
import danger from "./danger"
import template from "./template"

export default {
    task,scheduler,position,danger,template
}